export default import.meta.ROLLDOWN_FILE_URL_KV_E0twRcbPIhzxL8GygPA